export const CAREER_MAP = {
  '1': '1년 이하',
  '2': '2년',
  '3': '3년',
  '4': '4년',
  '5': '5년',
  '6': '6년',
  '7': '7년',
  '8': '8년',
  '9': '9년',
  '10': '10년',
  '11': '11년',
  '12': '12년',
  '13': '13년',
  '14': '14년',
  '15': '15년',
  '16': '16년',
  '17': '17년',
  '18': '18년',
  '19': '19년',
  '20': '20년 이상',
};
